module.exports = __webpack_public_path__ + "img/17.95c9e3a2.png";